import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      getMeImageGenerations: {
        keyArgs: ['isPublished'],
        merge(existing = { data: [], nextCursor: null }, incoming) {
          return {
            data: [...existing.data, ...incoming.data],
            nextCursor: incoming.nextCursor,
          };
        },
      },
      getMeVideoGenerations: {
        keyArgs: false,
        merge(existing = { data: [], nextCursor: null }, incoming) {
          return {
            data: [...existing.data, ...incoming.data],
            nextCursor: incoming.nextCursor,
          };
        },
      },
      getSavedPublications: {
        keyArgs: false,
        merge(existing = { data: [], nextCursor: null }, incoming) {
          return {
            data: [...existing.data, ...incoming.data],
            nextCursor: incoming.nextCursor,
          };
        },
      },
      getPublications: {
        keyArgs: false,
        merge(existing = { data: [], nextCursor: null }, incoming) {
          return {
            data: [...existing.data, ...incoming.data],
            nextCursor: incoming.nextCursor,
          };
        },
      },
      getPublicationsByUserId: {
        keyArgs: ['userId'],
        merge(existing = { data: [], nextCursor: null }, incoming) {
          return {
            data: [...existing.data, ...incoming.data],
            nextCursor: incoming.nextCursor,
          };
        },
      },
      getPublicationsForMe: {
        keyArgs: false,
        merge(existing = { data: [], nextCursor: null }, incoming) {
          return {
            data: [...existing.data, ...incoming.data],
            nextCursor: incoming.nextCursor,
          };
        },
      },
    },
  },
};
